import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import FanLeaderboard from './FanLeaderboard';
import { useProfile } from '../../context/ProfileContext';

const ArtistFansModal = ({ isOpen, onClose, artistId, artistName }) => {
  const { isDarkMode } = useProfile();

  if (!artistId) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          {/* Backdrop */}
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
          />

          {/* Modal Card */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className={`relative max-w-lg w-full rounded-[2.5rem] p-1 shadow-2xl overflow-hidden z-10 transition-colors duration-500 ${
              isDarkMode ? "bg-slate-900 border border-white/10" : "bg-white border border-slate-100"
            }`}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-5 right-6 z-20 w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 transition-all active:scale-90 text-slate-500 dark:text-slate-400 font-black"
            >
              ✕
            </button>

            

            {/* ✅ CLEANED CONTENT CONTAINER: Removed max-h and overflow rules to prevent the double scrollbar */}
            <div className="p-1">
              <FanLeaderboard artistId={artistId} />
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ArtistFansModal;